import { useContext } from 'react';
import { ASGContext, IASGContext } from '@palomina/palomina-website/context';

export const useASG = (): IASGContext => useContext(ASGContext);

export default useASG;
